
(function (angular) {
    'use strict';   
    /**
     * @ngdoc object
     * @name SMART2
     * @description
     * {@link https://angularjs.org/ AngularJS} project module of SMART 2.0 product
     * by {@link http://www.gep.com/ GEP} 
     */
    angular.module('SMART2', [
        'ui.router',       
        'ngAnimate',      
        'pascalprecht.translate',                     
        'smartHierarchyComponent',
        'ngFileUpload'
    ]);

    /*
     *   Dependency resolver provider to dynamically inject modules
     */
    angular.module('SMART2').factory('scriptCache', ['$cacheFactory', function ($cacheFactory) {
        return $cacheFactory('scriptCache', {
            capacity: 1000
        });
    }]);

    angular.module('SMART2').provider('dependencyResolver', ['$controllerProvider', '$provide', '$compileProvider', '$filterProvider', '$injector', function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector) {
        var moduleProviders = {
            $compileProvider: $compileProvider,
            $controllerProvider: $controllerProvider,
            $filterProvider: $filterProvider,
            $provide: $provide,
            $injector: $injector
        };

        var regModules = ["ng"];

        this.$get = function () {
            return this;
        };
        
        var resolveDependencies = function ($q, $http, $injector, $templateCache, scriptCache, dependencies, modules) {
            var defer = $q.defer();
            var dependenciesCounter = 0;
            if (angular.isDefined(dependencies) && dependencies.length > 0) {
                for (var i = 0; i < dependencies.length; i++) {
                    if (!scriptCache.get(dependencies[i])) {
                        if (dependencies[i].indexOf('.lib.js') > -1 || dependencies[i].indexOf('Libs.js') > -1 || dependencies[i].indexOf('LazyLoadedTemplate.js') > -1 || dependencies[i].indexOf('LazyLoadedTemplate.min.js') > -1) {
                            $.getScript(dependencies[i]).then(function (data) {
                                if (this.url.indexOf('LazyLoadedTemplate.js') > -1 || this.url.indexOf('LazyLoadedTemplate.min.js') > -1) {
                                    template($templateCache);
                                }
                                dependenciesCounter++;
                                if (dependenciesCounter == dependencies.length) {
                                    registerModules($injector, moduleProviders, modules, function () {
                                        defer.resolve();
                                    });
                                }
                            });
                        }
                        else {
                            (function (currentIndex) {
                                var currentScriptUrl = dependencies[currentIndex];
                                $http.get(currentScriptUrl, {
                                    errorHandlerConfigs: { preventAlert: true }
                                }).then(function (response) {
                                    if (response.data != null && (response.status == 200 || response.status == 304)) {
                                        response.data = response.data.replace(/angular.module\(("SMART2"|'SMART2')\).controller/g, "angular.module('SMART2').register.controller");
                                        response.data = response.data.replace(/angular.module\(("SMART2"|'SMART2')\).directive/g, "angular.module('SMART2').register.directive");
                                        response.data = response.data.replace(/angular.module\(("SMART2"|'SMART2')\).filter/g, "angular.module('SMART2').register.filter");
                                        response.data = response.data.replace(/angular.module\(("SMART2"|'SMART2')\).service/g, "angular.module('SMART2').register.service");
                                        response.data = response.data.replace(/angular.module\(("SMART2"|'SMART2')\).factory/g, "angular.module('SMART2').register.factory");
                                        response.data += '//# sourceURL=' + currentScriptUrl;
                                        eval(response.data);
                                    }
                                    dependenciesCounter++;
                                    if (dependenciesCounter == dependencies.length) {
                                        registerModules($injector, moduleProviders, modules, function () {
                                            defer.resolve();
                                        });
                                    }
                                });
                            })(i);
                        }
                        scriptCache.put(dependencies[i], 1);
                    }
                    else {
                        dependenciesCounter++;
                        if (dependenciesCounter == dependencies.length) {
                            defer.resolve();
                        }
                    }
                }
            }
            else {
                registerModules($injector, moduleProviders, modules, function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };
        this.resolveDependencies = resolveDependencies;
        var registerModules = function ($injector, providers, modules, callback) {
            var invokeQueue, moduleName, moduleFn, invokeArgs, provider;

            if (modules) {
                var runBlocks = [];
                for (var k = modules.length - 1; k >= 0; k--) {
                    moduleName = modules[k];
                    moduleFn = angular.module(moduleName);
                    runBlocks = runBlocks.concat(moduleFn._runBlocks);
                    invokeQueue = moduleFn._invokeQueue;

                    try {
                        for (var i = 0; i < invokeQueue.length; i++) {
                            invokeArgs = invokeQueue[i];

                            if (providers.hasOwnProperty(invokeArgs[0])) {
                                provider = providers[invokeArgs[0]];
                            }
                            else {
                                throw new Error('unsupported provider ' + invokeArgs[0]);
                            }
                            provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                        }

                        for (var i = 0; i < moduleFn._configBlocks.length; i++) {
                            invokeArgs = moduleFn._configBlocks[i];

                            if (angular.isArray(invokeArgs)) {
                                if (providers !== null) {
                                    if (providers.hasOwnProperty(invokeArgs[0])) {
                                        provider = providers[invokeArgs[0]];
                                    }
                                    else {
                                        throw new Error('unsupported provider ' + invokeArgs[0]);
                                    }
                                }

                                if (invokeArgs[1] !== 'invoke') {
                                    if (angular.isDefined(provider)) {
                                        provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                                    }
                                }
                                else {
                                    // config block
                                    if (angular.isFunction(invokeArgs[2][0]) && angular.isDefined(provider)) {
                                        provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                                    }
                                    else if (angular.isArray(invokeArgs[2][0])) {
                                        for (var j = 0; j < invokeArgs[2][0].length; j++) {
                                            if (angular.isFunction(invokeArgs[2][0][j]) && angular.isDefined(provider)) {
                                                provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    catch (e) {
                        if (e.message) {
                            e.message += ' from ' + moduleName;
                        }
                        throw new Error(e.message);
                    }
                    modules.pop();
                }
                angular.forEach(runBlocks, function (fn) {
                    $injector.invoke(fn);
                });
            }
            callback();
        };

        this.registerModules = function (modules, callback) {
            registerModules($injector, moduleProviders, modules, callback);
        }

        this.resolve = function (config) {
            var resolver = config.resolve ? config.resolve : {};
            var routeDef = {
                url: config.url,
                templateUrl: config.templateUrl,
                controller: config.controller,
                secure: config.secure ? secure : false,
                resolve: resolver.load ? resolver : angular.extend(config.resolve ? config.resolve : {}, {
                    load: ['$q', '$http', '$injector', '$templateCache', 'scriptCache', function ($q, $http, $injector, $templateCache, scriptCache) {
                        return resolveDependencies($q, $http, $injector, $templateCache, scriptCache, config.dependencies, config.modules);
                    }]
                })
            };
            return routeDef;
        };
    }]);
})(angular);
